const localInputSelector = '[data-input="user-code"]';
const foreignInputSelector = '[data-input="foreign-user-code"]';
const version = '1.0.0';
const callbackProgressHtml = '<div class="callback-progress input-group-append"><span class="input-group-text" id="addon-wrapping">&nbsp;<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">...</span></div>&nbsp;</span></div>';


class LocalUserCodeInput {
    constructor(options, context) {
        let that = this;
        let defaults = {};
        this.context = context;
        this.options = $.extend(true, {}, defaults, options || {});

        let $input = this.$input  = $(context);
        let $wrap = this.$wrap = this.$input.closest('.form-group');
        let $autoCompleteWrap = this.$autoCompleteWrap = $wrap.find('.list-group-autocomplete');

        this.$valuesWrap = this.$wrap.find('[data-user-codes]');
        this.$form = this.$wrap.closest('form');

        this.$input.on('blur', function (e) {

            if(e.relatedTarget && e.relatedTarget.hasAttribute('data-autocomplete-receiver-item')){
                //do nothing
            }else{
                setTimeout(function (){
                    $wrap.removeClass('autocomplete-show');
                }, 100);
            }

        });
        this.$input.on('focus', function (e) {
            that.searchSubject();
        });

        this.$input.on('keydown', function (event) {
            var keycode = parseInt(event.keyCode ? event.keyCode : event.which);
            if(keycode === 13){
                event.stopPropagation();
                return false;
            }
        });
        this.$input.on('keyup', function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode === 13){//enter

                /*
                $input.blur();
                return false;
                 */

                if(that.$autoCompleteWrap.find('button').length){
                    that.$autoCompleteWrap.find('button').first().click();
                }

            }else if(keycode === 27){//esc
                $wrap.removeClass('autocomplete-show');
            }else{
                that.searchSubject();
            }
        });

        $autoCompleteWrap.on('click', 'button', function () {
            $wrap.removeClass('autocomplete-show');
            $input.val($(this).data('code'));
            that.validateCode();
        });

        this.$wrap.on('click', '[data-user-code-remove]', function (e) {
            var $row = $(e.currentTarget).closest('[data-user-code]');
            this.removeRow($row);

        }.bind(this));

        this.checkValuesVisibility();
        console.log('LocalUserCodeInput inited for: ', context);


    }

    searchSubject(delay = true){

        if(delay){
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(function () {
                this.searchSubject(false);
            }.bind(this), 1000);
            return;
        }

        let that = this;

        if(this.searchXhr){
            this.searchXhr.abort();
        }

        let q = this.$input.val();

        if(q){

            that.showProgress();

            this.searchXhr = $.get(this.$input.data('search-url'), {
                q: this.$input.val(),
                ignore_users: this.getIgnoredUsers()
            }).done(function (response) {
                that.$autoCompleteWrap.html('');

                switch (response.status) {
                    case 'ok':
                        response.result.forEach(function (receiver) {
                            that.$autoCompleteWrap.append(
                                '<button data-autocomplete-receiver-item type="button" data-code="'+receiver.code+'" class="list-group-item list-group-item-action"><strong>'+receiver.safe_code+'</strong> '+receiver.name+'</button>'
                            );
                        });
                        break;
                    case 'error':
                        that.$autoCompleteWrap.html('<div class="bg-white p-2 text-danger">'+response.error+'</div>');
                        break;
                }

                that.$wrap.addClass('autocomplete-show');
            }).always(function () {
                that.hideProgress();
            });
        }else{
            that.$wrap.removeClass('autocomplete-show');
        }
    };

    validateCode() {
        var that = this;
        let $input = this.$input;

        let code = parseInt($input.val());

        //jei kodas nelygus textui, tai yra tiesiog paieska ir nedarom validacijos
        if(code != $input.val()) return;

        //if(!code || code == $input.data('value-validated')) return;

        that.showProgress($input);

        $.post($input.data('validate-url'), {
            code: code
        }).done(function (response) {
            if(response.status === "ok"){
                $input.removeClass('is-invalid').closest('.form-group').find('.invalid-feedback').html('');
                $input.val('');
                if(response.subject){
                    that.addSubject(response.subject);
                }
            }else{
                $input.addClass('is-invalid').closest('.form-group').find('.invalid-feedback').html(response.error);
            }
            $input.data('value-validated', $input.val());

        }).fail(function (e) {

        }).always(function () {
            that.hideProgress()
        })

    };

    hideProgress() {
        this.$input.attr('readonly', null);
        if(this.$input.next().hasClass('callback-progress')){
            this.$input.next().remove();
        }
    };
    showProgress() {
        this.$input.attr('readonly', 'readonly');

        if(this.$input.next().hasClass('callback-progress')) return;
        this.$input.after(callbackProgressHtml);
    };

    removeRow($row){
        if($row.find('input').val() === this.$input.val()){
            this.$input.val('');
            this.$input.data('value-validated', null);
        }
        $row.remove();
        this.checkValuesVisibility();
        this.$input.trigger('remove-subject');
    }

    addSubject(subject, triggerEvent = true) {
        if(!this.isSearchOnly()){
            var templateHtml = this.$wrap.find('template[data-user-row]').html();
            templateHtml = templateHtml.replace(/\[user_name]/gi, subject.name);
            templateHtml = templateHtml.replace(/\[user_id]/gi, subject.id);
            templateHtml = templateHtml.replace(/\[user_code]/gi, subject.safe_code);
            templateHtml = templateHtml.replace(/\[user_status]/gi, subject.status);
            templateHtml = templateHtml.replace(/\[user_status_style]/gi, subject.status_style);

            var $row = $(templateHtml);

            if(!this.isMultiple()){
                this.removeAllSubjects();
            }

            this.$wrap.find('[data-user-codes]').append($row);
            this.checkValuesVisibility();
        }

        if(triggerEvent){
            this.$input.trigger('add-subject', subject);
        }

    };

    removeAllSubjects(){
        this.$input.data('value-validated', null).val('');
        this.$valuesWrap.find('tr[data-user-code]').remove();
        this.checkValuesVisibility();
    }

    isSearchOnly(){
        return this.$input.data('search-only') == true;
    }
    isMultiple(){
        return this.$input.data('multiple') == true;
    }
    getIgnoredUsers(){
        let codes = [];

        let ignoredInputs = [
            this.$input.data('input_name')
        ];

        let ignoredUserCodesInputsNames = this.$input.data('ignored-user-codes');
        let ignoredUserIds = this.$input.data('ignored-user-ids');
        if(ignoredUserIds){
            ignoredUserIds.forEach(function (id){
                codes.push(parseInt(id))
            })
        }
        if(ignoredUserCodesInputsNames){
            ignoredUserCodesInputsNames = ignoredUserCodesInputsNames.split(',');
            ignoredInputs = ignoredInputs.concat(ignoredUserCodesInputsNames);
        }

        ignoredInputs.forEach(ignoredInputName => {
            this.$form.find("input[name='"+ignoredInputName+"[]'],input[name='"+ignoredInputName+"']").each(function (index, input){
                let id = $(input).val();
                if(id){
                    codes.push(id)
                }
            })
        })


        return codes;
    }

    checkValuesVisibility(){
        if(this.$valuesWrap.find('tr[data-user-code]').length === 0){
            this.$valuesWrap.closest('table').addClass('d-none');
        }else{
            this.$valuesWrap.closest('table').removeClass('d-none');
        }
    }
}
class ForeignUserCodeInput {
    constructor(options, context) {
        let defaults = {};
        this.context = context;
        this.options = $.extend(true, {}, defaults, options || {});

        this.$input  = $(context);
        this.$wrap = this.$input.closest('.form-group');
        this.group = this.$input.data('group');


        if(this.$wrap.length){
            this.$autoCompleteWrap = this.$wrap.find('.list-group-autocomplete');
            this.$autoCompleteWrap.on('click', 'button', function (e) {
                this.$wrap.removeClass('autocomplete-show');

                let data = $(e.currentTarget).data('data');
                this.fillFormData(data)
                this.$input.trigger('add-subject', data);

            }.bind(this));
        }

        this.$input.on('blur', function (e) {
            setTimeout(function (){
                this.$wrap.removeClass('autocomplete-show');
            }.bind(this), 100);
        }.bind(this));
        this.$input.on('focus', function (e) {
            this.searchSubject();
        }.bind(this));

        this.$input.on('keydown', function (event) {
            var keycode = parseInt(event.keyCode ? event.keyCode : event.which);
            if(keycode === 13){
                event.stopPropagation();
                return false;
            }
        }.bind(this));

        this.$input.on('keyup', function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode === 13){//enter
                this.$input.blur();
                return false;
            }else if(keycode === 27){//esc
                this.$wrap.removeClass('autocomplete-show');
            }else{
                this.searchSubject();
            }
        }.bind(this));

        console.log('ForeignUserCodeInput inited for: ', context);
    }

    searchSubject(delay = true){
        if(delay){
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(function () {
                this.searchSubject(false);
            }.bind(this), 500);
            return;
        }

        if(this.searchXhr){
            this.searchXhr.abort();
        }

        let q = this.$input.val();



        if(q){
            this.searchXhr = $.get(this.$input.data('search-url'), {
                q: this.$input.val(),
            }).done(function (response) {
                this.$autoCompleteWrap.html('');
                response.forEach(function (receiver) {
                    let $button = $('<button type="button" class="list-group-item list-group-item-action"><strong>'+receiver.code+'</strong> '+receiver.name+'</button>')
                    $button.data('data', receiver);
                    this.$autoCompleteWrap.append($button);
                }.bind(this));
                this.$wrap.addClass('autocomplete-show');
            }.bind(this)).always(function () {
            });
        }else{
            this.$wrap.removeClass('autocomplete-show');
        }
    };

    fillFormData(receiverData){
        let $form = this.$wrap.closest('form');

        if($form.length){
            $form.find('input[name="'+this.group+'"]').val(receiverData.id);
            $form.find(':input[data-foreign-group="'+this.group+'"]').each(function (index, input) {
                //pasalinam priekini prefiksa (foreign_code => code)
                let dataName = input.name.replace(/[^_]+_/, '');
                switch (input.type) {
                    case 'text':
                    case 'select-one':
                        $(input).val(receiverData[dataName]).change();
                        break;
                    case 'radio':
                        if(input.value === receiverData[dataName]){
                            input.checked = true;
                            $(input).change();
                        }
                        break;
                }
            })
        }
    }

    hideProgress() {
        this.$input.attr('readonly', null);
        if(this.$input.next().hasClass('callback-progress')){
            this.$input.next().remove();
        }
    };
    showProgress() {
        this.$input.attr('readonly', 'readonly');

        if(this.$input.next().hasClass('callback-progress')) return;
        this.$input.after(callbackProgressHtml);
    };
}
class UserCodeInput {

    static init($context = null){

        let $localInputs = $context ? $context.find(localInputSelector) : $(localInputSelector);
        $localInputs.each(function (index, element) {
            if($(element).data('user_code_instance')) return;
            let user_code_instance = new LocalUserCodeInput({}, this);
            $(element).data('user_code_instance', user_code_instance)
        });

        let $foreignInputs = $context ? $context.find(foreignInputSelector) : $(foreignInputSelector);
        $foreignInputs.each(function (index, element) {
            if($(element).data('user_code_instance')) return;
            let user_code_instance = new ForeignUserCodeInput({}, this);
            $(element).data('user_code_instance', user_code_instance)
        });
    }
}

if(typeof module === "undefined"){
    $(function() {
        UserCodeInput.init();
    });
}else{
    UserCodeInput.init();
    module.exports = UserCodeInput
}